<template>
  <div class="tw-flex tw-flex-col tw-items-stretch tw-gap-5 tw-w-full">
    <StakeAutocomplete
      :items="sortedItems"
      :init-selected="initSelected"
      :multiple="multiple"
      :loading="loading"
      :has-fetched="hasFetched"
      @search="scheduleSearch"
      @selection-change="emit('selection-change', $event)"
    >
      <template #default="slotProps">
        <slot v-bind="slotProps" />
      </template>
    </StakeAutocomplete>
  </div>
</template>


<script setup>
import StakeAutocomplete from '@stakeui/StakeAutocomplete.vue';

import {
  ref,
  // reactive,
  computed,
  // watch,
  onMounted,
  // defineEmits,
  defineProps,
} from 'vue';

import { useAdvisorStore } from '@frontend/ui/stores/advisorStore.js';
const advisorStore = useAdvisorStore();

import { debounce } from 'lodash';


const props = defineProps({
  // Any items that should be selected to start (editing an existing list)
  // Pass through to StakeAutocomplete
  initSelected: {
    type: Array,
    default: () => [],
  },
  endpoint: {
    type: String,
    required: true,
  },
  searchParam: {
    type: String,
    default: 'search',
  },
  resultsField: {
    type: String,
    default: 'results',
  },
  sortBy: {
    type: String,
    default: 'name',
  },
  multiple: {
    type: Boolean,
    default: true,
  },
});


// Reactive state
const searchQuery = ref('');
const items = ref([]);
const defaultItems = ref([]);
const loading = ref(false);
const hasFetched = ref(false);

// Computed props

const fullEndpoint = computed(() => {
  if (!props.endpoint.startsWith('http')) {
    return window.location.origin + props.endpoint;
  }
  return props.endpoint;
});


const sortedItems = computed(() => {
  if (!items.value || items.value.length === 0) return [];

  return [...items.value].sort((a, b) => {
    if (a[props.sortBy] < b[props.sortBy]) return -1;
    if (a[props.sortBy] > b[props.sortBy]) return 1;
    return 0;
  });
});


// Regular methods

const scheduleSearch = query => {
  searchQuery.value = query;

  if (!query && defaultItems.value.length > 0) {
    items.value = defaultItems.value;
    return;
  }
  loading.value = true;
  debouncedFetchItems();
};


const fetchItems = async () => {
  const url = new URL(fullEndpoint.value);

  if (searchQuery.value) {
    url.searchParams.append(props.searchParam, searchQuery.value);
  }

  loading.value = true;

  const res = await fetch(url.toString(), {
    method: 'GET',
    headers: advisorStore.headers,
  });
  const data = await res.json();

  const results = data[props.resultsField];
  items.value = results;

  if (defaultItems.value.length === 0 && !searchQuery.value) {
    defaultItems.value = results;
  }
  loading.value = false;
  hasFetched.value = true;
};

const debouncedFetchItems = debounce(fetchItems, 300);


// Events
const emit = defineEmits(['selection-change']);


// Lifecycle hooks
onMounted(() => {
  debouncedFetchItems();
});

</script>


<style scoped>

</style>
